import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import { Box, Fab } from '@mui/material';
import { getShiftStatusText } from '../../../utils/storageUtil';

import PopOverMenuComponent from '../../../components/PopOverMenuComponent';
interface DayBoxProps {
  onEventClick: (offsetNum: any, currentDate: any, shiftId?: any) => void;
  currentDay: any;
  weekDays: any[];
  crew: any;
  currentIndex: number;
  shifts: any[];
  handleMoreMenu: (type: any, id: any, date: any) => void;
}
const DayBox: React.FC<DayBoxProps> = ({
  onEventClick,
  currentDay,
  weekDays,
  crew,
  currentIndex,
  shifts,
  handleMoreMenu,
}) => {
  const truncateText = (text: string, maxLength: number) => {
    return text.length > maxLength ? text.slice(0, maxLength) + '…' : text;
  };
  const moreIconMenuItems = [
    { label: 'Delete', type: 'delete' },
    { label: 'Duplicate', type: 'duplicate' },
  ];
  const moreIconMenuItemsNoDelete = [{ label: 'Duplicate', type: 'duplicate' }];

  return (
    <Box
      key={currentIndex}
      sx={{
        minHeight: 130,
        borderRight: '1px solid #dedede',
        position: 'relative',

        '&:hover .fabbox': {
          opacity: 1,
          visibility: 'visible',
        },
      }}
    >
      <Box id={'shiftBox_' + currentIndex} className="shitboxparent">
        {shifts && (
          <Box className="shiftBoxMain">
            {shifts.map((shiftData: any, index: any) => {
              return (
                <Box className="shiftBox">
                  <PopOverMenuComponent
                    sx={{
                      position: 'absolute',

                      right: '-7px',
                      float: 'right',
                    }}
                    isVertical={true}
                    title="Shift Options"
                    handleMenuClick={(type: any) => {
                      handleMoreMenu(type, shiftData.shiftId, shiftData.date);
                    }}
                    menuItems={
                      shiftData.shiftStatus.id === 0
                        ? moreIconMenuItems
                        : moreIconMenuItemsNoDelete
                    }
                  />

                  <Box
                    onClick={() => {
                      onEventClick(crew.id, currentDay, shiftData.shiftId);
                      console.log(crew.id);
                      console.log(currentDay);
                    }}
                  >
                    {shiftData.project && (
                      <Box>{shiftData.project.projectId}</Box>
                    )}

                    <Box>{shiftData.project.projectName}</Box>
                    <Box>{truncateText(shiftData.siteAddress, 28)}</Box>
                    <Box
                      style={{
                        backgroundColor: '#001e3c',
                        color: '#00e5ff',
                        borderRadius: '25px',
                        fontWeight: 600,
                        padding: '4px 8px',
                        fontSize: '12px',
                        width: '90%',
                        textAlign: 'center',
                      }}
                    >
                      {getShiftStatusText(shiftData.shiftStatusId)}
                    </Box>
                  </Box>
                </Box>
              );
            })}
          </Box>
        )}
        <Fab
          className="fabbox"
          sx={{
            ...fabStyle,
            transition: 'opacity 0.3s',
            opacity: 0,
            visibility: 'hidden',
          }}
          color="primary"
          aria-label="add"
          size={'small'}
          onClick={() => {
            onEventClick(crew.id, currentDay);
            console.log(crew.id);
            console.log(currentDay);
          }}
        >
          <AddIcon sx={{ color: '#fff' }} />
        </Fab>
      </Box>
    </Box>
  );
};

export default DayBox;
const fabStyle = {
  position: 'absolute',
  bottom: 6,
  right: 6,
};
// background: rgba(0, 244, 255, 0.06);
//     height: 90%;
//     font-size: 14px;
//     padding: 5px;
//     box-shadow: antiquewhite;
//     /* width: 90%; */
//     margin: 0 auto;
// }
